module.exports = __webpack_public_path__ + "img/g0222.c4f74171.png";